import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { AppConfigService } from "src/app/services/app-config.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private user: any = null;
  private readonly userDetailsUrl: string = "";

  constructor(
    private readonly http: HttpClient,
    private readonly envService: AppConfigService,
  ) {
    this.userDetailsUrl = this.envService.mmpCurrentUserDetailsUrl;
  }

  /**
   * Sets the user details in the service.
   * @param user - The user object to store.
   */
  setUser(user: any): void {
    this.user = user;
  }

  /**
   * Gets the stored user details.
   * @returns The stored user object.
   */
  getUser(): any {
    return this.user;
  }

  /**
   * Fetches user details from the API based on the provided dnumber.
   * @param dnumber - The dnumber of the user to fetch details for.
   * @returns An Observable containing the user details.
   */
  fetchUserDetails(dnumber: string): Observable<any> {
    const requestBody = { user_dnumber: dnumber };

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return this.http
      .post<any>(this.userDetailsUrl, requestBody, { headers })
      .pipe(
        map((response) => this.sanitizeResponse(response)), // Sanitize the response
      );
  }

  private sanitizeResponse(response: any): any {
    // Example: Remove any potentially dangerous HTML or script tags
    if (typeof response === "object" && response !== null) {
      for (const key in response) {
        if (response.hasOwnProperty(key) && typeof response[key] === "string") {
          response[key] = response[key]
            .replaceAll("<", "&lt;")
            .replaceAll(">", "&gt;");
        }
      }
    }
    return response;
  }
}
